import {SaleProductSummaryModel} from "./saleProductSummary.model";

export class SaleProductModel {
    summary: SaleProductSummaryModel;
}